import React from "react";
import { useSite } from "../../context/SiteContext";
import { ArrowUp } from "lucide-react";

const Footer = () => {
  const { profile } = useSite();
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-[#0a0a0a] border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-stone-500 mb-6">
              Colophon
            </p>
            <h3 className="font-display text-4xl md:text-6xl text-stone-50 leading-[1.02]">
              Let's <span className="italic text-amber-200">talk.</span>
            </h3>
            <a
              href={`mailto:${profile.email}`}
              className="mt-6 inline-block font-display text-xl md:text-2xl text-stone-200 link-anim"
            >
              {profile.email}
            </a>
          </div>

          <div className="md:col-span-5 flex flex-col justify-between">
            <div className="grid grid-cols-2 gap-6 text-sm">
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-stone-500 mb-3">
                  Elsewhere
                </p>
                <ul className="space-y-2">
                  <li><a className="link-anim text-stone-300" href={profile.socials.linkedin} target="_blank" rel="noreferrer">LinkedIn</a></li>
                  <li><a className="link-anim text-stone-300" href={profile.socials.youtube} target="_blank" rel="noreferrer">Based-AF / YouTube</a></li>
                  <li><a className="link-anim text-stone-300" href={profile.socials.website} target="_blank" rel="noreferrer">Legacy site</a></li>
                </ul>
              </div>
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-stone-500 mb-3">
                  Based in
                </p>
                <p className="text-stone-300">{profile.location}</p>
                <p className="text-stone-500 text-xs mt-1">Originally {profile.origin}</p>
              </div>
            </div>

            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="self-start mt-10 group inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] text-stone-300 hover:text-amber-300 transition-colors"
            >
              <span className="w-9 h-9 rounded-full border border-stone-600 group-hover:border-amber-300 flex items-center justify-center">
                <ArrowUp size={14} />
              </span>
              Back to top
            </button>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-zinc-900 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-[11px] uppercase tracking-[0.22em] text-stone-500">
            © {year} Daniel Flynn — All rights reserved
          </p>
          <p className="text-[11px] uppercase tracking-[0.22em] text-stone-600">
            Set in Playfair Display &amp; Inter · Built in Dublin
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
